import { Date_toDateString, Date_toDateTimeString } from "../../../common/dateUtils";
import { FormState_PopulateErrorMessages } from "../../../common/formStateUtils";
import { String_removePrefix } from "../../../common/stringUtils";
import MaritimeEventRequest from "../../requests/MaritimeEventRequest";
import Errors from "../../responses/Errors";
import FormElement, { formElement } from "../FormElement";
import PersonFormElement, {
    PersonFormElement_default,
    PersonFormElement_toPerson,
    PersonFormElement_populateErrorMessages
} from "../PersonFormElement";
import PositionPickerRow, {
    PositionPickerRow_default,
    PositionPickerRow_toPosition,
    PositionPickerRows_populateErrorMessages
} from "./PositionPickerRow";
import { MaritimeEventType } from "../../../common/enums";

type MaritimeEventFormState = {
    remindMe: FormElement<boolean>;
    remindMeDate: FormElement<Date>;
    startDate: FormElement<Date>;
    endDate: FormElement<Date>;
    adminComment: FormElement<string>;
    contactPerson: PersonFormElement;
    description: FormElement<string>;
    expirationReminderEmail: FormElement<string>;
    expirationReminderPhoneNumber: FormElement<string>;
    entrepreneur: FormElement<string>;
    positions: PositionPickerRow[];
    maritimeEventType: FormElement<MaritimeEventType>;
};

export default MaritimeEventFormState;

export function MaritimeEventFormState_default(): MaritimeEventFormState {
    const defaultFormState: MaritimeEventFormState = {
        adminComment: formElement(""),
        contactPerson: PersonFormElement_default(),
        description: formElement(""),
        endDate: formElement(new Date()),
        entrepreneur: formElement(""),
        expirationReminderEmail: formElement(""),
        expirationReminderPhoneNumber: formElement(""),
        positions: [PositionPickerRow_default()],
        remindMe: formElement(false),
        remindMeDate: formElement(new Date()),
        startDate: formElement(new Date()),
        maritimeEventType: formElement(MaritimeEventType.General)
    };

    return defaultFormState;
}

export function MaritimeEventFormState_toRequest(formState: MaritimeEventFormState): MaritimeEventRequest {
    const request: MaritimeEventRequest = {
        adminComment: formState.adminComment.value,
        contactPerson: PersonFormElement_toPerson(formState.contactPerson),
        description: formState.description.value,
        endDate: Date_toDateTimeString(formState.endDate.value),
        entrepreneur: formState.entrepreneur.value,
        expirationReminderEmail: formState.expirationReminderEmail.value,
        expirationReminderPhoneNumber: formState.expirationReminderPhoneNumber.value,
        positions: formState.positions.map(PositionPickerRow_toPosition),
        remindMe: formState.remindMe.value,
        remindMeDate: Date_toDateString(formState.remindMeDate.value),
        startDate: Date_toDateTimeString(formState.startDate.value),
        maritimeEventType: formState.maritimeEventType.value
    };

    return request;
}

export function MaritimeEventFormState_populateErrorMessages(
    formState: MaritimeEventFormState,
    errors: Errors
): MaritimeEventFormState {
    const errorKeys = Object.keys(errors);

    const positionsErrorKeys = errorKeys.filter((e) => e.startsWith("Positions"));
    const positionErrors = Object.fromEntries(
        positionsErrorKeys.map((k) => [String_removePrefix(k, "Positions"), errors[k]])
    );

    const contactPersonErrorKeys = errorKeys.filter((e) => e.startsWith("ContactPerson."));
    const contactPersonErrors = Object.fromEntries(
        contactPersonErrorKeys.map((k) => [String_removePrefix(k, "ContactPerson."), errors[k]])
    );

    const updatedFormState = FormState_PopulateErrorMessages(formState, errors);
    updatedFormState.positions = PositionPickerRows_populateErrorMessages(formState.positions, positionErrors);

    updatedFormState.contactPerson = PersonFormElement_populateErrorMessages(
        formState.contactPerson,
        contactPersonErrors
    );

    return updatedFormState;
}
